import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ShipTheory_ds_country_codesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { Country?: string, Alpha2?: string, Alpha3?: string, CountryCode?: string, Region?: string, SubRegion?: string, IntermediateRegion?: string, RegionCode?: string, SubRegionCode?: string, IntermediateRegionCode?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/ShipTheory/datasources/ds_country_codes/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, $keys: string[] }): Promise<{ result?: { Country?: string, Alpha2?: string, Alpha3?: string, CountryCode?: string, Region?: string, SubRegion?: string, IntermediateRegion?: string, RegionCode?: string, SubRegionCode?: string, IntermediateRegionCode?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ShipTheory/datasources/ds_country_codes/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string    }) {
      return false;
    }
}
